import React, { useEffect, useRef, useState } from "react";
import performRequest from "../../api/request";
import { useNavigate, useParams } from "react-router";
import Showlivewebinar from "./webinar player/aws_player";
import "video.js/dist/video-js.css";
import { MdOutlineLiveTv } from "react-icons/md";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { Toast } from "../../CustomComponent/toast";
import WebinarCountdown from "./webinarCountDown";
import { socket } from "../../api/socket.io";
import { useSelector } from "react-redux";
import SimpleButton from "../../Components/layouts/simple_button";
const LiveStreamPage = () => {
  const { id } = useParams();

  const store = useSelector((store) => store?.login?.user);
  const [webinarDate, setWebinarDate] = useState();
  const [webinarStartTime, setWebinarStartTime] = useState();
  const [webinarStatus, setWebinarStatus] = useState("");
  const [showWebinar, setShowWebinar] = useState(false);
  const [isValidUser, setIsValidUser] = useState(false);
  const [isValidUserError, setIsValidUserError] = useState("");
  const navigate = useNavigate();
  const socketConnected = useRef(false); // Prevent multiple connects
  const [userData, setUserData] = useState();
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [issueFacing, setIssueFacing] = useState("");
  const [image, setImage] = useState(null);
  const [bugWebinarDate, setBugWebinarDate] = useState(null);

  useEffect(() => {
    if (
      store?.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
      window?.location?.host?.includes("localhost")
    ) {
      return;
    } else {
      const handleKeyDown = (e) => {
        if (
          e.key === "F12" ||
          (e.ctrlKey &&
            e.shiftKey &&
            (e.key === "I" || e.key === "J" || e.key === "C")) ||
          (e.ctrlKey && e.key === "U")
        ) {
          e.preventDefault();
          alert("Action not allowed.");
        }
      };
      const handleContextMenu = (e) => e.preventDefault();
      const handleCopy = (e) => e.preventDefault();

      document.addEventListener("keydown", handleKeyDown);
      document.addEventListener("contextmenu", handleContextMenu);
      document.addEventListener("copy", handleCopy);

      return () => {
        document.removeEventListener("keydown", handleKeyDown);
        document.removeEventListener("contextmenu", handleContextMenu);
        document.removeEventListener("copy", handleCopy);
      };
    }
  }, []);

  function generateUUID() {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
      return crypto.randomUUID();
    }
    // Fallback method if crypto.randomUUID isn't available
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  const initializeSocket = () => {
    socket?.on("forceLogout", () => {
      alert(
        "This link is restricted to a single user. You have been logged out because it was accessed from another device or browser."
      );
      sessionStorage.clear();
      window.location.href = "/";
    });
  };

  const registerSocket = (sessionToken, deviceId, userId, webinarId) => {
    if (!sessionToken || !deviceId || !userId || socketConnected.current)
      return;

    socket?.emit("registerSession", {
      sessionToken,
      deviceId,
      userId,
      webinarId,
    });

    socketConnected.current = true;
  };

  const handleLogoutAllDevices = async (data) => {
    let deviceId = generateUUID();
    sessionStorage.setItem("deviceId", deviceId);
    socket?.emit("logoutSession", {
      sessionToken: data?.sessionToken,
      deviceId,
      userId: data?.email,
      webinarId: data?.webinarId,
    });

    const sessionRes = await performRequest(
      "POST",
      `webinar/verifyUserSesssion/${id}`,
      {
        token: id,
        deviceId,
        webinarId: data?.webinarId,
      }
    );

    if (sessionRes?.status === 200) {
      sessionStorage.setItem("deviceId", deviceId);
      const sessionToken = sessionRes?.data?.data?.sessionToken;
      sessionStorage.setItem("userPersistantSession", sessionToken);
      const userId = sessionRes?.data?.data?.email;
      const webinarId = sessionRes?.data?.data?.webinarId;
      sessionStorage.setItem("webinarUserId", userId);
      setIsValidUser(true);
      setIsValidUserError("");
      registerSocket(sessionToken, deviceId, userId, webinarId);
    }
  };

  const handleCountdownUpdate = (time) => {
    setShowWebinar(false);
    setIsValidUser(true);
  };
  useEffect(() => {
    initializeSocket();
    let deviceId = sessionStorage.getItem("deviceId");
    let sessionToken = sessionStorage.getItem("userPersistantSession");
    let userId = sessionStorage.getItem("webinarUserId");
    let webinarId = sessionStorage.getItem("webinarId");
    performRequest("POST", `webinar/verifyUserToken/${id}`, {
      deviceId,
      sessionToken,
      userId,
      webinarId,
    })
      .then((res) => {
        const tokenUserData = res?.data?.data;
        setUserData(tokenUserData);
        setWebinarStatus(res?.data?.data?.webinarStatus);
        if (res?.data?.data?.deviceId !== deviceId) {
          return;
        }
        if (tokenUserData) {
          registerSocket(sessionToken, deviceId, userId, webinarId);
        }
        setIsValidUser(true);
      })
      .catch((err) => {
        if (err?.response?.status && err?.response?.data?.msg) {
          Toast("error", err?.response?.data?.msg);
          if (err?.response?.data?.msg === "Webinar Expired") {
            alert(err?.response?.data?.msg);
            // navigate("/webinar-ended");
          }
        } else {
          CustomErrorResponse(err);
        }
        setWebinarStatus(err?.response?.data?.msg);
        setIsValidUserError(err?.response?.data?.msg);
        setIsValidUser(false);
        setWebinarStartTime(err?.response?.data?.webinar?.webinarStartTime);
        setWebinarDate(err?.response?.data?.webinar?.webinarDate);
      });
  }, [id]);

  const checkLoginInanotherDevice = (userData) => {
    let deviceId = sessionStorage?.getItem("deviceId");
    if (userData?.deviceId !== deviceId) {
      const shouldLogoutOthers = window.confirm(
        "You're logged in on another device. Logout all others?"
      );
      if (shouldLogoutOthers) {
        handleLogoutAllDevices(userData);
      } else {
        sessionStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    if (userData) {
      checkLoginInanotherDevice(userData);
    }
  }, [userData]);

  useEffect(() => {
    const checkDevice = () => {
      let deviceId = sessionStorage.getItem("deviceId");
      let sessionToken = sessionStorage.getItem("userPersistantSession");
      let userId = sessionStorage.getItem("webinarUserId");
      let webinarId = sessionStorage.getItem("webinarId");
      performRequest("POST", `webinar/verifyUserToken/${id}`, {
        deviceId,
        sessionToken,
        userId,
        webinarId,
      })
        .then((res) => {
          const tokenUserData = res?.data?.data;
          checkLoginInanotherDevice(tokenUserData);
        })
        .catch((err) => console.error(err));
    };

    const intervalId = setInterval(checkDevice, 60000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const handleWebinarUserId = (data) => {
      let userId = data.userId;
      let webinarId = data.webinarId;
      sessionStorage.setItem("webinarUserId", userId);
      sessionStorage.setItem("webinarId", webinarId);
    };

    socket?.on("webinarUserId", handleWebinarUserId);
    return () => {
      socket?.off("webinarUserId", handleWebinarUserId);
    };
  }, []);

  const handleShowWebinar = () => {
    if (isValidUser === true) {
      setShowWebinar(true);
    } else {
      if (!isValidUserError) {
        Toast("error", "Please refresh the page");
      } else {
        Toast("error", isValidUserError);
      }
    }
  };

  const handleReportAnIssue = () => {
    const formData = new FormData();
    formData.append("mobile", mobile);
    formData.append("email", email);
    formData.append("issueFacing", issueFacing);
    formData.append("webinarDate", bugWebinarDate);
    if (image) {
      formData.append("image", image); // image is the File object
    }
    for (let [key, value] of formData.entries()) {
      if (!value) {
        Toast("error", `Please provide ${key} before submitting.`);
        return; // stop function execution
      }
    }

    performRequest("POST", "/webinar/webinar-issue-report", formData)
      .then((res) => {
        if (res.data) {
          Toast("success", "Issue Raised Successfully");
          window.location.reload();
        }
      })
      .catch((error) => {
        CustomErrorResponse(error);
      });
  };

  return (
    <div
      className="container-xl  card mt-2 mb-5 border-0 p-0 bg-transparent"
      style={{ overflow: "hidden" }}
    >
      {!showWebinar ? (
        <div className="row mt-lg-8 align-items-center justify-content-center">
          <div
            className="col-lg-6 col-md-12 d-flex flex-column justify-content-center align-items-center bg-black text-white p-4 rounded-3"
            style={{ minHeight: "50vh" }}
          >
            {webinarStatus === "running" ? (
              <>
                <div
                  className="fw-bold text-center"
                  style={{ fontSize: "1.1rem", maxWidth: "80%" }}
                >
                  Webinar Started
                  <br></br>
                  <p>Please Join</p>
                  <MdOutlineLiveTv
                    style={{ fontSize: "40px", marginTop: "2px" }}
                  />
                </div>
              </>
            ) : webinarStatus === "Webinar Expired" ? (
              <p>Webinar Expired</p>
            ) : (
              <div
                className="fw-bold text-center"
                style={{ fontSize: "1.1rem", maxWidth: "80%" }}
              >
                Webinar will start on schedule date and time.
                <br></br>
                <p>Please Wait...</p>
                {webinarDate && webinarStartTime && (
                  <WebinarCountdown
                    webinarDate={webinarDate}
                    webinarStartTime={webinarStartTime}
                    onCountdownUpdate={handleCountdownUpdate}
                  />
                )}
                <MdOutlineLiveTv
                  style={{ fontSize: "40px", marginTop: "2px" }}
                />
              </div>
            )}

            <div></div>
          </div>

          <div
            className="col-lg-6 col-md-12 d-flex flex-column justify-content-center align-items-center text-center p-4"
            style={{ minHeight: "50vh" }}
          >
            <h1
              className="fw-bold d-none d-md-block"
              style={{ fontSize: "60px" }}
            >
              Ready to join?
            </h1>
            <h1 className="fw-bold d-md-none" style={{ fontSize: "40px" }}>
              Ready to join?
            </h1>
            {webinarStatus === "running" ? (
              <p
                className="mt-3"
                style={{ fontSize: "1.5rem", fontWeight: "500" }}
              >
                The webinar is now filling up with participants.
              </p>
            ) : (
              <p
                className="mt-3"
                style={{ fontSize: "1.5rem", fontWeight: "500" }}
              >
                No one else is here
              </p>
            )}

            <button
              className="btn btn-primary mt-4 fw-bold"
              onClick={() => handleShowWebinar()}
              style={{
                fontSize: "1.5rem",
                borderRadius: "40px",
                padding: "0.8rem 2rem",
                maxWidth: "250px",
              }}
            >
              Join Now
            </button>
            <a
              className="mt-2 text-red"
              data-bs-toggle="modal"
              data-bs-target="#modal-report-1"
              id="opensuccessmodal"
              // onClick={() => alert("lshdf")}
            >
              Report An Issue
            </a>
          </div>
        </div>
      ) : (
        <Showlivewebinar userData={userData} />
      )}

      <div
        className="modal modal-blur fade"
        id="modal-report-1"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Report An Issue</h5>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="btn-close"
              ></button>
            </div>
            <div className="modal-body">
              {true && (
                <>
                  <div className="mb-3 row">
                    <p className="mb-1">
                      ⚠️ Before submitting, please try these steps:
                    </p>
                    <p className="mb-1">
                      🔄 Refresh the page before reporting.
                    </p>
                    <p className="mb-1">
                      📱 Remember: Only <b>one device</b> is allowed per user.
                    </p>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3 required">
                      Registered Email
                    </label>
                    <div className="w-100 col">
                      {/* {notificationData?.email || "N/A"} */}
                      <input
                        type="email"
                        className="form form-select"
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3 required">
                      Registered Phone Number
                    </label>
                    <div className="w-100 col">
                      <input
                        type="number"
                        className="form form-select"
                        onChange={(e) => {
                          setMobile(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3 required">
                      Webinar Date
                    </label>
                    <div className="w-100 col">
                      <input
                        type="date"
                        className="form form-control"
                        onChange={(e) => {
                          setBugWebinarDate(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3 required">
                      Issue Facing ??
                    </label>
                    <div className="w-100 col">
                      <textarea
                        type="text"
                        maxLength={300}
                        className="form form-select"
                        onChange={(e) => {
                          setIssueFacing(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                  {/* <div className="mb-3 row">
                    <label className="w-25 form-label col-3 required"></label>
                    <div className="w-100 col">
                      <textarea
                        type="text"
                        maxLength={300}
                        className="form form-select"
                      />
                    </div>
                  </div> */}
                  <div className="mb-3 row">
                    <label className="col-3 form-label required">
                      Upload Image
                    </label>
                    <div className="col">
                      <input
                        type="file"
                        className="form-control"
                        onChange={(e) => {
                          if (e.target.files && e.target.files.length > 0) {
                            setImage(e.target.files[0]); // save first selected file
                          }
                        }}
                      />
                      <span className="text-muted">
                        📷 Upload screenshot of the bug
                      </span>
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="modal-footer">
              {/* <div>
                <SimpleButton
                  buttonText="Not Connected"
                  type="secondary"
                  data-bs-dismiss="modal"
                />
              </div> */}

              <div className="ms-auto">
                <SimpleButton
                  onClick={() => handleReportAnIssue()}
                  buttonText="Submit"
                  data-bs-dismiss="modal"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveStreamPage;
